import {
  Button,
  Card,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { ReactFlowProvider } from '@xyflow/react';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import '@xyflow/react/dist/style.css';
import { ScenarioDiagramContext } from '../../../state/Context';
import ScenarioFlow from '../diagrams/ScenarioFlow';
import JourneyDialog from '../diagrams/JourneyDialog';
import { useScenarioPatientCategoryMapQuery } from '../../../network/queries';
import { Loader, Toolbar } from '../../common';

import HeaderCard from './HeaderCard';

function PatientsStep({ onBack, onNext }) {
  const { t } = useTranslation();

  const [state, setState] = useState({
    open: false,
    data: {},
    activePatientCategory: '',
  });
  const memoizedState = useMemo(() => ({ state, setState }), [state]);

  const { scenarioId } = useParams();
  const { isLoading: isLoadingPatientCategoryMap, data: patientCategoryMap } =
    useScenarioPatientCategoryMapQuery(scenarioId);

  return isLoadingPatientCategoryMap ? (
    <Loader />
  ) : (
    <Stack spacing={2} sx={{ height: '100%' }}>
      <HeaderCard title={t('pages.scenarios.configure.patients.title')}>
        <Typography>
          {t('pages.scenarios.configure.patients.subheader')}
        </Typography>
      </HeaderCard>
      <ScenarioDiagramContext.Provider value={memoizedState}>
        <ReactFlowProvider>
          <Grid container spacing={3} sx={{ height: '100%' }}>
            <Grid size={9}>
              <ScenarioFlow />
            </Grid>
            <Grid size={3}>
              <Card sx={{ height: '100%' }}>
                <Typography variant="h5" color="primary" sx={{ px: 2, pt: 2 }}>
                  {t('pages.scenarios.configure.patients.categories')}
                </Typography>
                <List>
                  {(isLoadingPatientCategoryMap ? [] : patientCategoryMap).map(
                    (patientCategory) => (
                      <ListItemButton
                        key={patientCategory.id}
                        selected={
                          state.activePatientCategory === patientCategory.id
                        }
                        onClick={() =>
                          setState((prev) => ({
                            ...prev,
                            activePatientCategory: patientCategory.id,
                          }))
                        }
                      >
                        <ListItemText primary={patientCategory.name} />
                      </ListItemButton>
                    ),
                  )}
                </List>
              </Card>
            </Grid>
          </Grid>
        </ReactFlowProvider>
        <JourneyDialog />
      </ScenarioDiagramContext.Provider>
      <Toolbar>
        <Button onClick={onBack}>{t('common.back')}</Button>
        <Button onClick={onNext}>{t('common.next')}</Button>
      </Toolbar>
    </Stack>
  );
}

export default PatientsStep;
